import { Alert, Slide, type SlideProps } from '@mui/material';
import Snackbar, { type SnackbarCloseReason } from '@mui/material/Snackbar';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { removeShownSnackPack } from '../redux/reducers/common.js';
import { getSnackPack } from '../redux/selectors.js';


function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="up" />;
}

export interface SnackbarMessage {
  message: string;
  key: number;
  error: boolean;
}

export default function ConsecutiveSnackbars() {
  const snackPack = useSelector(getSnackPack);
  const [open, setOpen] = React.useState(false);
  const [messageInfo, setMessageInfo] = React.useState<SnackbarMessage | undefined>(undefined);
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (snackPack.length && !messageInfo) {
      // Set a new snack when we don't have an active one
      setMessageInfo({ ...snackPack[0] });
      dispatch(removeShownSnackPack());
      setOpen(true);
    } else if (snackPack.length && messageInfo && open) {
      // Close an active snack when a new one is added
      setOpen(false);
    }
  }, [snackPack, messageInfo, open, dispatch, removeShownSnackPack]);

  const handleClose = (_: React.SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleExited = () => {
    setMessageInfo(undefined);
  };

  return (
    <div>
      <Snackbar
        key={messageInfo ? messageInfo.key : undefined}
        open={open}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        autoHideDuration={6000}
        onClose={handleClose}
        TransitionComponent={SlideTransition}
        TransitionProps={{ onExited: handleExited }}
      >
        <Alert
          onClose={handleClose}
          severity={messageInfo?.error ? 'error' : 'success'}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {messageInfo ? messageInfo.message : null}
        </Alert>
      </Snackbar>
    </div>
  );
}
